import { MessageCircle } from "lucide-react";

function trackWhatsApp(location) {
  if (window.gtag) {
    window.gtag('event', 'conversion', { send_to: 'AW-9363810582/whatsapp_click' });
    window.gtag('event', 'conversion', { send_to: 'AW-18025861296/whatsapp_click' });
    window.gtag('event', 'whatsapp_click', { event_category: 'engagement', event_label: location });
  }
  if (window.fbq) window.fbq('track', 'Contact', { content_name: 'WhatsApp - ' + location });
}

function trackPhoneCall(location) {
  if (window.gtag) {
    window.gtag('event', 'conversion', { send_to: 'AW-9363810582/phone_call' });
    window.gtag('event', 'conversion', { send_to: 'AW-18025861296/phone_call' });
    window.gtag('event', 'phone_call', { event_category: 'engagement', event_label: location });
  }
  if (window.fbq) window.fbq('track', 'Contact', { content_name: 'Phone - ' + location });
}

export { trackWhatsApp, trackPhoneCall };

export default function WhatsAppButton() {
  return (
    <a
      href="https://wa.me/553125550207?text=Ol%C3%A1%2C%20gostaria%20de%20solicitar%20uma%20cota%C3%A7%C3%A3o%20de%20seguro."
      target="_blank"
      rel="noopener noreferrer"
      className="fixed bottom-6 right-6 z-50 flex items-center justify-center w-14 h-14 rounded-full bg-[#25D366] text-white shadow-lg hover:bg-[#1da851] transition-colors whatsapp-float"
      data-testid="whatsapp-float-btn"
      aria-label="Falar no WhatsApp"
      onClick={() => trackWhatsApp('floating_button')}
    >
      <MessageCircle className="h-6 w-6" />
    </a>
  );
}
